<template>
  <div class="details">
    <div class="octobus__columns">
      <div class="octobus__column is-two-thirds">
        <p class="carrier is-size-7 has-text-weight-light is-hidden-desktop">{{$t('ticket.carrier', {carrier: carrier})}}</p>
        <Route
          :routes="routes"
        />
      </div>
      <div class="octobus__column is-one-third">
        <div class="octobus__columns" v-if="isChange">
          <div class="octobus__column is-narrow">
            <div class="octobus__field">
              <input
                v-model="bus"
                id="bus"
                type="checkbox"
                name="bus"
                class="switch is-outlined"
              >
              <label for="bus">{{raceName}}</label>
            </div>
          </div>
        </div>
        <Info
          :busInfo="busInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Route from './Route';
import Info from './Info';

export default {
  name: 'Details',
  components: {
    Route,
    Info,
  },
  props: {
    routes: {
      type: Array,
      required: true,
    },
    carrier: {
      type: String,
    },
  },
  data() {
    return {
      bus: false,
    };
  },
  methods: {
  },
  computed: {
    isChange() {
      return Boolean(this.routes.length > 1);
    },
    raceName() {
      return this.routes[Number(this.bus)].raceName;
    },
    busInfo() {
      return this.routes[Number(this.bus)].info;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Ticket/Details.vue